// longeva-view-transitions.js
// Intercept clicks on Longeva-marked cards and same-origin nav links so
// the page-to-page navigation uses the View Transitions API. Browsers
// without the API fall through to standard navigation.
// ~700 bytes.

(function () {
  'use strict';
  if (!document.startViewTransition) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('click', function (e) {
    // Honour user intent: middle-click / cmd-click / ctrl-click open new tab,
    // do not intercept.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.button !== undefined && e.button !== 0) return;

    var link = e.target.closest(
      '.longeva-brand-rail__card,' +
      '.longeva-editorial__card,' +
      '.longeva-product-card,' +
      '.longeva-indication-grid__card,' +
      '.longeva-hero__cta'
    );
    if (!link || !link.href) return;
    // Only intercept same-origin
    try {
      if (new URL(link.href).origin !== location.origin) return;
    } catch (err) {
      return;
    }

    e.preventDefault();
    document.startViewTransition(function () {
      window.location.href = link.href;
    });
  });
})();
